export const container = `top-[54px] bottom-0 h-auto`;
